import { Dispatch, SetStateAction, useCallback } from 'react'
import styles from '../Reports.module.css'
import { Dropdown } from '../../../components/Dropdown'
import {
    SummaryType,
    BetStatuses,
    BetOutcomes,
    BetProviders,
    capitalize,
    BetGraded,
} from '../helpers'
import { ReportFilterIF } from '../types'

export const ReportFilters = (props: {
    filters: ReportFilterIF
    selectedFilters: ReportFilterIF
    setSelectedFilters: Dispatch<SetStateAction<ReportFilterIF>>
    showSummary?: SummaryType | undefined
    setShowSummary?: Dispatch<SetStateAction<SummaryType | undefined>>
    dropdown?: boolean
}) => {
    const {
        filters,
        selectedFilters,
        showSummary,
        setShowSummary,
        setSelectedFilters,
        dropdown,
    } = props

    const onFilterButtonClick = useCallback(
        (
            label: string,
            type:
                | 'status'
                | 'account'
                | 'outcome'
                | 'user'
                | 'provider'
                | 'source'
                | 'error'
                | 'graded'
        ) => {
            switch (type) {
                case 'status':
                    if (selectedFilters.status.includes(label))
                        setSelectedFilters({
                            ...selectedFilters,
                            status: selectedFilters.status.filter(
                                (s) => s !== label
                            ),
                        })
                    else
                        setSelectedFilters({
                            ...selectedFilters,
                            status: [...selectedFilters.status, label],
                        })
                    break
                case 'outcome':
                    if (selectedFilters.outcome.includes(label))
                        setSelectedFilters({
                            ...selectedFilters,
                            outcome: selectedFilters.outcome.filter(
                                (o) => o !== label
                            ),
                        })
                    else
                        setSelectedFilters({
                            ...selectedFilters,
                            outcome: [...selectedFilters.outcome, label],
                        })
                    break
                case 'user':
                    if (selectedFilters.user.includes(label))
                        setSelectedFilters({
                            ...selectedFilters,
                            user: selectedFilters.user.filter(
                                (u) => u !== label
                            ),
                        })
                    else
                        setSelectedFilters({
                            ...selectedFilters,
                            user: [...selectedFilters.user, label],
                        })
                    break
                case 'provider':
                    if (selectedFilters.provider.includes(label))
                        setSelectedFilters({
                            ...selectedFilters,
                            provider: selectedFilters.provider.filter(
                                (p) => p !== label
                            ),
                        })
                    else
                        setSelectedFilters({
                            ...selectedFilters,
                            provider: [...selectedFilters.provider, label],
                        })
                    break
                case 'error':
                    if (selectedFilters.error.includes(label))
                        setSelectedFilters({
                            ...selectedFilters,
                            error: selectedFilters.error.filter(
                                (p) => p !== label
                            ),
                        })
                    else
                        setSelectedFilters({
                            ...selectedFilters,
                            error: [...selectedFilters.error, label],
                        })
                    break
                case 'graded':
                    if (selectedFilters.graded.includes(label))
                        setSelectedFilters({
                            ...selectedFilters,
                            graded: selectedFilters.graded.filter(
                                (p) => p !== label
                            ),
                        })
                    else
                        setSelectedFilters({
                            ...selectedFilters,
                            graded: [...selectedFilters.graded, label],
                        })
                    break
                // for account and source, reset other filters
                case 'account':
                    if (selectedFilters.account[0] === label)
                        setSelectedFilters({
                            provider: [],
                            status: [],
                            outcome: [],
                            user: [],
                            source: [],
                            account: [],
                            error: [],
                            graded: []
                        })
                    else
                        setSelectedFilters({
                            provider: [],
                            status: [],
                            outcome: [],
                            user: [],
                            source: [],
                            account: [label],
                            error: [],
                            graded: []
                        })
                    break
                case 'source':
                    if (selectedFilters.source.includes(label))
                        setSelectedFilters({
                            provider: [],
                            status: [],
                            outcome: [],
                            user: [],
                            account: [],
                            source: [],
                            error: [],
                            graded: []
                        })
                    else
                        setSelectedFilters({
                            provider: [],
                            status: [],
                            outcome: [],
                            user: [],
                            account: [],
                            source: [label],
                            error: [],
                            graded: []
                        })
            }
        },
        [selectedFilters, setSelectedFilters]
    )

    const onFilterDropdownSelect = useCallback(
        (label: string | undefined, type: 'Account' | 'Source' | 'Error') => {
            if (type === 'Source') {
                if (label) {
                    if (label !== 'Summary') {
                        onFilterButtonClick(label, 'source')
                        showSummary === SummaryType.SOURCE &&
                            setShowSummary &&
                            setShowSummary(undefined)
                    } else {
                        setShowSummary && setShowSummary(SummaryType.SOURCE)
                        setSelectedFilters({
                            provider: [],
                            outcome: [],
                            user: [],
                            status: [],
                            account: [],
                            source: [],
                            error: [],
                            graded: []
                        })
                    }
                } else if (showSummary === SummaryType.SOURCE) {
                    setShowSummary && setShowSummary(undefined)
                } else {
                    setSelectedFilters({
                        provider: [],
                        outcome: [],
                        user: [],
                        status: [],
                        account: [],
                        source: [],
                        error: [],
                        graded: []
                    })
                }
            }
            if (type === 'Account') {
                if (label) {
                    if (label !== 'Summary') {
                        onFilterButtonClick(label, 'account')
                        setShowSummary && setShowSummary(undefined)
                    } else {
                        setShowSummary && setShowSummary(SummaryType.ACCOUNT)
                        setSelectedFilters((prev) => ({
                            provider: [],
                            outcome: [],
                            user: [],
                            status: [],
                            account: [],
                            source: prev.source,
                            error: [],
                            graded: []
                        }))
                    }
                } else if (showSummary === SummaryType.ACCOUNT) {
                    setShowSummary && setShowSummary(undefined)
                } else {
                    setSelectedFilters({
                        provider: [],
                        outcome: [],
                        user: [],
                        status: [],
                        source: [],
                        account: [],
                        error: [],
                        graded: []
                    })
                }
            }
            if (type === 'Error') {
                if (label) {
                    if (label !== 'Summary') {
                        onFilterButtonClick(label, 'error')
                        setShowSummary && setShowSummary(undefined)
                    } else {
                        setShowSummary && setShowSummary(SummaryType.ERROR)
                        setSelectedFilters((prev) => ({
                            provider: [],
                            outcome: [],
                            user: [],
                            status: [],
                            account: [],
                            source: prev.source,
                            error: [],
                            graded: []
                        }))
                    }
                } else if (showSummary === SummaryType.ERROR) {
                    setShowSummary && setShowSummary(undefined)
                } else {
                    setSelectedFilters({
                        provider: [],
                        outcome: [],
                        user: [],
                        status: [],
                        source: [],
                        account: [],
                        error: [],
                        graded: []
                    })
                }
            }
        },
        [setSelectedFilters, showSummary, setShowSummary, onFilterButtonClick]
    )

    const FilterButton = useCallback(
        (props: {
            label: string
            type:
            | 'status'
            | 'outcome'
            | 'account'
            | 'user'
            | 'provider'
            | 'source'
            | 'graded'
        }) => {
            const { label, type } = props
            const filter =
                type === 'status'
                    ? BetStatuses[label as keyof typeof BetStatuses]
                    : type === 'outcome'
                        ? BetOutcomes[label as keyof typeof BetOutcomes]
                        : type === 'provider'
                            ? BetProviders[label as keyof typeof BetProviders]
                            : type === 'graded' ? BetGraded[label as keyof typeof BetGraded] : undefined

            return (
                <div
                    key={label}
                    className={`${styles.button} ${filter
                        ? filter.style.button
                        : type === 'user'
                            ? styles.button_user
                            : type === 'source'
                                ? styles.button_source
                                : undefined
                        } ${type === 'status'
                            ? selectedFilters.status.includes(label) &&
                            filter &&
                            filter.style.selected
                            : type === 'outcome'
                                ? selectedFilters.outcome.includes(label) &&
                                filter &&
                                filter.style.selected
                                : type === 'provider'
                                    ? selectedFilters.provider.includes(label) &&
                                    filter &&
                                    filter.style.selected
                                    : type === 'user'
                                        ? selectedFilters.user.includes(label) &&
                                        styles.selected_user
                                        : type === 'source'
                                            ? selectedFilters.source.includes(label) &&
                                            styles.selected_source
                                            : type === 'graded'
                                                ? selectedFilters.graded.includes(label) && filter && filter.style.selected
                                                : undefined
                        }`}
                    onClick={() => onFilterButtonClick(label, type)}
                >
                    {filter?.label ?? label}
                </div>
            )
        },
        [onFilterButtonClick, selectedFilters]
    )

    if (dropdown)
        return (
            <div className={styles.dropdown_container}>
                <div className={styles.dropdown}>
                    <Dropdown
                        options={
                            setShowSummary &&
                                showSummary !== SummaryType.ACCOUNT
                                ? ['Summary', ...filters.source]
                                : filters.source
                        }
                        onSelect={(source) =>
                            onFilterDropdownSelect(source, 'Source')
                        }
                        value={
                            showSummary === SummaryType.SOURCE
                                ? 'Summary'
                                : selectedFilters.source[0]
                        }
                        placeholder="Source"
                        search
                        clear
                    />
                </div>
                {(!showSummary || showSummary === SummaryType.ACCOUNT) && (
                    <div className={styles.dropdown}>
                        <Dropdown
                            options={
                                setShowSummary
                                    ? ['Summary', ...filters.account]
                                    : filters.account
                            }
                            onSelect={(account) =>
                                onFilterDropdownSelect(account, 'Account')
                            }
                            value={
                                showSummary === SummaryType.ACCOUNT
                                    ? 'Summary'
                                    : selectedFilters.account[0]
                            }
                            placeholder="Account"
                            search
                            clear
                        />
                    </div>
                )}
                <div className={styles.dropdown}>
                    <Dropdown
                        options={
                            setShowSummary
                                ? ['Summary', ...filters.error]
                                : filters.error
                        }
                        onSelect={(error) =>
                            onFilterDropdownSelect(error, 'Error')
                        }
                        value={
                            showSummary === SummaryType.ERROR
                                ? 'Summary'
                                : selectedFilters.error[0]
                        }
                        placeholder="Error"
                        search
                        clear
                    />
                </div>
            </div>
        )

    return (
        <div className={styles.filters}>
            {
                <>
                    {filters.provider.length > 0 && (
                        <div className={styles.filter_button_container}>
                            {filters.provider
                                .filter((p) =>
                                    Object.keys(BetProviders).includes(p)
                                )
                                .sort((a, b) => {
                                    const valA =
                                        BetProviders[
                                            a as keyof typeof BetProviders
                                        ]?.order ?? null
                                    const valB =
                                        BetProviders[
                                            b as keyof typeof BetProviders
                                        ]?.order ?? null

                                    if (
                                        valA !== null &&
                                        valB !== null &&
                                        valA !== valB
                                    ) {
                                        return valA - valB
                                    }
                                    return a.localeCompare(b)
                                })
                                .map((provider) => (
                                    <FilterButton
                                        key={provider}
                                        label={provider}
                                        type="provider"
                                    />
                                ))}
                        </div>
                    )}

                    {filters.outcome.filter((o) => !!o).length > 0 && (
                        <div className={styles.filter_button_container}>
                            {filters.outcome
                                .filter((o) => !!o)
                                .sort((a, b) => {
                                    const valA =
                                        BetOutcomes[
                                            a as keyof typeof BetOutcomes
                                        ]?.order ?? null
                                    const valB =
                                        BetOutcomes[
                                            b as keyof typeof BetOutcomes
                                        ]?.order ?? null

                                    if (
                                        valA !== null &&
                                        valB !== null &&
                                        valA !== valB
                                    ) {
                                        return valA - valB
                                    }
                                    return a.localeCompare(b)
                                })
                                .map((outcome) => (
                                    <FilterButton
                                        key={outcome}
                                        label={outcome}
                                        type="outcome"
                                    />
                                ))}
                        </div>
                    )}

                    {filters.status.length > 0 && (
                        <div className={styles.filter_button_container}>
                            {filters.status
                                .sort((a, b) => {
                                    const valA =
                                        BetStatuses[
                                            a as keyof typeof BetStatuses
                                        ]?.order ?? null
                                    const valB =
                                        BetStatuses[
                                            b as keyof typeof BetStatuses
                                        ]?.order ?? null

                                    if (
                                        valA !== null &&
                                        valB !== null &&
                                        valA !== valB
                                    ) {
                                        return valA - valB
                                    }
                                    return a.localeCompare(b)
                                })
                                .map((status) => (
                                    <FilterButton
                                        key={status}
                                        label={capitalize(status)}
                                        type="status"
                                    />
                                ))}
                        </div>
                    )}

                    {filters.graded.length > 0 && (
                        <div className={styles.filter_button_container}>
                            {filters.graded
                                .sort((a, b) => {
                                    const valA =
                                        BetGraded[
                                            a as keyof typeof BetGraded
                                        ]?.order ?? null
                                    const valB =
                                        BetGraded[
                                            b as keyof typeof BetGraded
                                        ]?.order ?? null

                                    if (
                                        valA !== null &&
                                        valB !== null &&
                                        valA !== valB
                                    ) {
                                        return valA - valB
                                    }
                                    return a.localeCompare(b)
                                })
                                .map((grade) => (
                                    <FilterButton
                                        key={grade}
                                        label={capitalize(grade)}
                                        type="graded"
                                    />
                                ))}
                        </div>
                    )}

                    {filters.user.length > 0 && (
                        <div className={styles.filter_button_container}>
                            {filters.user.map((user) => (
                                <FilterButton
                                    key={user}
                                    label={user}
                                    type="user"
                                />
                            ))}
                        </div>
                    )}
                </>
            }
        </div>
    )
}
